import { useState } from 'react';
import ReactDOM from 'react-dom';

import Chat from './Chat';
import Feeds from './Feeds';
import Video from './Video';

import './index.css';

const App = () => {
  const app = import.meta.env.VITE_APP;

  const [Component] = useState<any | undefined>(() => {
    if (app === 'feeds') {
      return Feeds;
    }

    if (app === 'video') {
      return Video;
    }

    return Chat;
  });

  if (Component) {
    return (
      <>
        <Component />
      </>
    );
  }
  return null;
};

ReactDOM.render(<App />, document.getElementById('root'));
